module.exports = __webpack_public_path__ + "img/knife_survival_bowie.d4dbb706.svg";